'use client';

import {useCallback, useContext, useSyncExternalStore} from 'react';
import {ActiveScreenIdSubscriptionContext} from './ActiveScreenIdProvider';

/**
 * Returns the currently active screen ID — i.e. the first element of the
 * selectedScreenIds array. Re-renders only when this primary id changes,
 * not when other ids are added/removed from the multi-selection.
 */
export function useActiveScreenId(): string | null {
  const {subscribe, getSnapshot} = useContext(
    ActiveScreenIdSubscriptionContext,
  );

  const getActive = useCallback(() => getSnapshot()[0] ?? null, [getSnapshot]);

  return useSyncExternalStore(subscribe, getActive, getActive);
}
